import {isMobileDevice, isTabletDevice} from "./device";

/**
 * Fix the compatibility of dispatch event
 * @param elem The HTML element to attach event
 * @param eventType The name of event
 */
function dispatchEvent(elem: HTMLElement, eventType: string): boolean {
    if (elem) {
        let event: Event;
        if (typeof (Event) === "function") {
            event = new Event(eventType);
        } else { // fix IE
            event = document.createEvent("Event");
            event.initEvent(eventType, true, true);
        }
        return elem.dispatchEvent(event);
    }
}

/**
 * Get the click or touchstart event if it is a device
 * @param namespace The namespace of event
 * @returns {string} The name of the event, touchstart (mobile) or mouse (desktop)
 */
function getClickDevice(namespace?: string): string {
    const isDevice = isMobileDevice() || isTabletDevice();
    const np = namespace ? `.${namespace}` : "";
    return `${isDevice ? "touchstart" : "click"}${np}`;
}

/**
 * On unload, prevents Firefox bug
 */
function fixBackHistory() {
    if (!window.onunload) {
        // tslint:disable-next-line:only-arrow-functions
        window.onunload = function() { /* - */ };
    }
}

/**
 * Add event listener with pageShow type
 * @param listener
 */
function pageShow(listener: (this: Window, ev: PageTransitionEvent) => any) {
    window.addEventListener("pageshow", listener);
}

/**
 * Add event listener with pageHide type
 * @param listener
 */
function pageHide(listener: (this: Window, ev: PageTransitionEvent) => any) {
    window.addEventListener("pagehide", listener);
}

/**
 * Action triggered on return to page
 * @param action
 * exemple:
 *     // Remove loader from bfcache
 *     atPageBack(() => {
 *         removeLoader();
 *     });
 */
function atPageBack(action?: (evt: PageTransitionEvent) => void) {
    pageShow((evt: PageTransitionEvent) => {
        // @ts-ignore
        const navigationType = performance.getEntriesByType("navigation")[0]?.type;
        if (navigationType === "back_forward" || evt.persisted) {
            action(evt);
        }
    });
}

export {
    dispatchEvent,
    getClickDevice,
    fixBackHistory,
    pageShow,
    pageHide,
    atPageBack,
};
